import { render, staticRenderFns } from "./MouthsLoader.vue?vue&type=template&id=639d361c&"
import script from "./MouthsLoader.vue?vue&type=script&lang=js&"
export * from "./MouthsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports